/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListSlackDirectoryConnectionsRequest,
  ListSlackDirectoryConnectionsSecurity,
} from "../models/operations/listslackdirectoryconnections.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildSlackDirectoryConnectionsQuery,
  prefetchSlackDirectoryConnections,
  queryKeySlackDirectoryConnections,
  SlackDirectoryConnectionsQueryData,
} from "./slackDirectoryConnections.core.js";
export {
  buildSlackDirectoryConnectionsQuery,
  prefetchSlackDirectoryConnections,
  queryKeySlackDirectoryConnections,
  type SlackDirectoryConnectionsQueryData,
};

export type SlackDirectoryConnectionsQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * list slackDirectoryConnections
 */
export function useSlackDirectoryConnections(
  request?: ListSlackDirectoryConnectionsRequest | undefined,
  security?: ListSlackDirectoryConnectionsSecurity | undefined,
  options?: QueryHookOptions<
    SlackDirectoryConnectionsQueryData,
    SlackDirectoryConnectionsQueryError
  >,
): UseQueryResult<
  SlackDirectoryConnectionsQueryData,
  SlackDirectoryConnectionsQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildSlackDirectoryConnectionsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * list slackDirectoryConnections
 */
export function useSlackDirectoryConnectionsSuspense(
  request?: ListSlackDirectoryConnectionsRequest | undefined,
  security?: ListSlackDirectoryConnectionsSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    SlackDirectoryConnectionsQueryData,
    SlackDirectoryConnectionsQueryError
  >,
): UseSuspenseQueryResult<
  SlackDirectoryConnectionsQueryData,
  SlackDirectoryConnectionsQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildSlackDirectoryConnectionsQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setSlackDirectoryConnectionsData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: SlackDirectoryConnectionsQueryData,
): SlackDirectoryConnectionsQueryData | undefined {
  const key = queryKeySlackDirectoryConnections(...queryKeyBase);

  return client.setQueryData<SlackDirectoryConnectionsQueryData>(key, data);
}

export function invalidateSlackDirectoryConnections(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: [
      "@gram/client",
      "slackDirectoryConnections",
      "list",
      ...queryKeyBase,
    ],
  });
}

export function invalidateAllSlackDirectoryConnections(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "slackDirectoryConnections", "list"],
  });
}
